<!-- 左边导航栏 -->
<template>
  <div class="leftBar">
    <a-menu
      mode="inline"
      :default-selected-keys="activekey"
      :style="{ height: '100%', borderRight: 0 }"
      :getPopupContainer="triggerNode => triggerNode.parentNode"
    >
      <template v-for="(item, index) in routerlist">
        <a-menu-item v-if="!item.children" :key="item.path">
          <router-link :to="item.path">
            <a-icon :type="item.meta.icon" />
            <span>{{ item.meta.title }}</span>
          </router-link>
        </a-menu-item>
        <a-sub-menu v-else :key="index" :getPopupContainer="triggerNode => triggerNode.parentNode">
          <span slot="title">
            <a-icon :type="item.meta.icon" />
            <span>{{ item.meta.title }}</span>
          </span>
          <a-menu-item v-for="key in item.children" :key="key.path">
            <router-link :to="key.path"> {{ key.meta.title }}</router-link>
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>
  </div>
</template>

<script>
import { getItem } from "@/utils/storage";
export default {
  data() {
    return {
      routerlist: [],
      activekey: [],
      admin: null,
    };
  },


  // {
  //       path: "/camera",
  //       name: "camera",

  //       hidden: true,
  //       component: () => import("../views/camera/camera.vue"),
  //       // 如果需要添加子菜单,请将文件改为index,然后添加即可
  //       meta: {
  //         icon: "",
  //         title: "摄像头画面",
  //       },
  //     },
  mounted() {
    let menuList = JSON.parse(getItem("menuList"))
    console.log(menuList);

    //定义一下局域网摄像头
    let jyw = {}
    jyw.path = "/local-camera"
    jyw.name = "local-camera"
    jyw.hidden = true
    jyw.meta = {
        icon:"",
        title:"摄像头画面"
    }

    let jysPath = '/camera/local-camera'
    jyw.component=() => import('../views'+jysPath+'.vue')

    
    this.activekey[0] = this.$route.path;

    console.log(this.$route.options);

    let newMenu = []
    newMenu.push(jyw)
    for(let i=0;i<menuList.length;i++){
      let menuTmp = {}
      menuTmp.path = menuList[i].path
      menuTmp.name = menuList[i].path
      menuTmp.hidden = false
      menuTmp.meta = {
        icon:menuList[i].icon,
        title:menuList[i].name
      }

      menuTmp.component=()=>import('../views'+menuList[i].path+'.vue')
      
      if(menuList[i].children!=null){
        menuTmp.children = []
        let mtc0 = menuList[i].children
        for(let j=0;j<mtc0.length;j++){
          let mtc = {}
          mtc.path = mtc0[j].path
          mtc.name = mtc0.path
          mtc.hidden = false
          mtc.component=()=>import('../views'+mtc0[j].path+'.vue')
          mtc.meta = {
            
            title:mtc0[j].name
          }
          menuTmp.children.push(mtc)
        }
      }
      newMenu.push(menuTmp)
    }
    console.log("888888888888888888888");
    console.log(newMenu)

    this.$router.options.routes[1].children = newMenu
    
    this.routerlist = this.$router.options.routes[1].children.filter(
      (item, index) => {
        if (item.children) {
          item.children = item.children.filter((item) => {
            if (!item.hidden) return item;
          });
        }
        if (item.path == "/system") {
          this.admin === "admin"
            ? (item.hidden = false)
            : (item.hidden = true);
        }
        return !item.hidden && item;
      }
    );
  },
  methods: {},
  computed: {
  },
  watch: {},
  created() {
    this.admin=getItem('username')
  },
};
</script>

<style lang="scss" scoped>
.leftBar {
  height: calc(100% - 40px);
}
</style>
